import axios, { AxiosRequestConfig } from 'axios';
import UserModule from '@/store/modules/user';
import { ApiResponseData } from './apiModels';
import qs from 'qs';
import { Dialog, Toast } from 'vant';

interface ApiRequestOptions extends AxiosRequestConfig {
  reqName?: string;
  headers?: { [key: string]: any };
  data?: any;
}

export interface ILoginReturnData {
  userName: string;
  access_token: string;
  expires_in: number;
  token_type: string;
}

const defaultAxiosOptions: AxiosRequestConfig = {
  //baseURL: 'https://spider.ch2lab.cn:1443',
  baseURL: process.env.VUE_APP_ROOT,
  timeout: 1000 * 60 * 5,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  maxContentLength: 1024 * 1024 * 20,
  method: 'GET',
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
};

const apiAxios = axios.create(defaultAxiosOptions);
apiAxios.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      const time = new Date().getTime();
      if (config.params) {
        config.params = Object.assign(config.params, { t: time });
      } else {
        config.params = { t: time };
      }
    }
    if (UserModule.getToken) {
      config.headers.Authorization = 'Bearer ' + UserModule.getToken;
    }
    return config;
  },
  error => {
    // Handle request error here
    // Promise.reject(error);
  }
);

// respone 拦截器
apiAxios.interceptors.response.use(
  response => {
    const { data } = response;
    if (data.code === 401) {
      UserModule.LogOut().then(() => {
        sessionStorage.clear();
        location.href = getUrl();
      });
    }
    if (Object.keys(data).indexOf('code') >= 0) {
      if (data.code !== 200) {
        console.log(`服务器操作错误：`, data);
        Toast.fail(`错误，code=${data.code}.${data.message ? data.message : data.data}`);
        throw new Error(data.message || data.data);
      }
    }
    return response;
  },
  error => {
    let msg = error.toString();
    // message.error({ content: error.response.data.message, duration: 3 * 1000 });
    if (error.response) {
      console.log('API ERROR error.response:', error.response);
      switch (error.response.status) {
        case 401:
          UserModule.LogOut().then(() => {
            sessionStorage.clear();
            location.href = getUrl();
          });

          break;
        case 403:
          msg = `code=403: ${error.response.data.message}`;
          Toast.fail(msg);
          break;
        case 500:
          msg = `code=500: 服务器错误:${error.response.data} `;
          console.log(msg, error);
          Toast.fail(msg);
          break;
        default:
          msg = `code=403: ${error.response.data.message}`;
          Toast.fail(msg);
      }
    } else {
      console.log('API ERROR:', error);
      Toast.fail(`错误:response=${error}`);
    }
    return Promise.reject(msg);
  }
);

function getUrl() {
  const url =
    process.env.NODE_ENV === 'development'
      ? '/'
      : 'https://m.gbjygl.gxela.gov.cn/index.html#/?' +
        '&classId=' +
        getUrlParam('classId') +
        '&opreateType=' +
        getUrlParam('opreateType') +
        '&classType=' +
        getUrlParam('classType');
  return url;
}

function getUrlParam(key: string) {
  let p = window.location.href.toString().split('?')[1];
  let params = new URLSearchParams(p);
  const value = params.get(key);
  if (value) {
    return value;
  }
  return '';
}

async function apiRequest<R>(reqOptions: ApiRequestOptions): Promise<R> {
  const options = Object.assign(defaultAxiosOptions, reqOptions);

  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await apiAxios(reqOptions);
      resolve(res.data as R);
    } catch (error) {
      reject(error);
    }
  });

  return promise as Promise<R>;
  // return apiAxios( reqOptions ) as any as Promise<R>;
}

async function apiSendAsync<R>(method: string, url: string, data: any, params: any): Promise<R> {
  const options = Object.assign(defaultAxiosOptions, {
    url,
    method,
    data: JSON.stringify(data),
    params,
  });

  const promise = new Promise(async (resolve, reject) => {
    try {
      const res = await apiAxios(options);
      resolve(res.data as R);
    } catch (error) {
      reject(error);
    }
  });
  return promise as Promise<R>;
}
export default apiRequest;
export { apiRequest, ApiRequestOptions, apiSendAsync };
